export default "__VITE_ASSET__DgbCOWPo__"